import type { components } from '@joyful/openapi/types.gen'
import { createEnumSchema } from '@joyful/utils'
import type { EnumValueMeta } from '@joyful/utils'

import type { BadgeProps } from '../Badge'
import { Badge } from '../Badge'

export const PracticeRequestStatusSchema = createEnumSchema<
  components['schemas']['PracticeRequestStatus'],
  EnumValueMeta & { variant: BadgeProps['variant'] }
>([
  { title: `Draft`, value: 'DRAFT', variant: 'warning' },
  { title: `Pending approval`, value: 'PRE_PUBLISHED', variant: 'warning' },
  { title: `Open`, value: 'OPEN', variant: 'success' },
  { title: `Closed`, value: 'CLOSED', variant: 'neutral' },
  { title: `Deleted`, value: 'DELETED', variant: 'neutral' },
])

export interface PracticeRequestStatusBadgeProps extends Partial<
  Omit<BadgeProps, 'children' | 'variant'>
> {
  status: components['schemas']['PracticeRequestStatus']
}

export function PracticeRequestStatusBadge({
  status,
  ...badgeProps
}: PracticeRequestStatusBadgeProps) {
  const metadata = PracticeRequestStatusSchema.meta(status)
  return (
    <Badge {...badgeProps} variant={metadata.variant}>
      {metadata.title}
    </Badge>
  )
}
